module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title) ? _c('h2', [_vm._v("OBS! " + _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "4px"
    }
  }, [_c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Välj " + _vm._s(_vm._f("dateRange")([_vm.params.startDate, _vm.params.endDate])))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('a', {
    staticClass: "small-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("Avbryt och sök nya datum")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d57b682"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SummerConfirmationModal.vue
// module id = 932
// module chunks = 0